import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { Container, Row, Col } from 'reactstrap'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import PhysicalPerson from './physicalPerson'
import Oficios from './oficios'
import Labs from './labs'
import LegalPerson from './legalPerson'
import Project from './project'
import Documents from './documents'
import Departments from './departments'
import Sectors from './sectors'
import Activities from './activities'
import Services from './services'
import Breadcrumbs from '../../components/Common/Breadcrumb'

class Admin extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { user } = this.props.auth

    if (user.perm_id === 1) {
      return (
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title="Administrador"
              breadcrumbItems={[]}
            />

            <Row>
              <Col>
                <Tabs>
                  <TabList>
                    <Tab>Pessoas Físicas</Tab>
                    <Tab>Pessoas Jurídicas</Tab>
                    <Tab>Projetos</Tab>
                    <Tab>Documentos</Tab>
                    <Tab>Serviços</Tab>
                    <Tab>Departamentos</Tab>
                    <Tab>Setores</Tab>
                    <Tab>Atividades</Tab>
                    <Tab>Ofícios</Tab>
                    <Tab>Labs</Tab>
                  </TabList>

                  <TabPanel>
                    <PhysicalPerson />
                  </TabPanel>

                  <TabPanel>
                    <LegalPerson />
                  </TabPanel>

                  <TabPanel>
                    <Project />
                  </TabPanel>

                  <TabPanel>
                    <Documents />
                  </TabPanel>

                  <TabPanel>
                    <Services />
                  </TabPanel>

                  <TabPanel>
                    <Departments />
                  </TabPanel>

                  <TabPanel>
                    <Sectors />
                  </TabPanel>

                  <TabPanel>
                    <Activities />
                  </TabPanel>

                  <TabPanel>
                    <Oficios />
                  </TabPanel>

                  <TabPanel>
                    <Labs user={user} />
                  </TabPanel>
                </Tabs>
              </Col>
            </Row>
          </Container>
        </div>
      )
    }

    return <Redirect to="/" />
  }
}

const mapStateToProps = state => ({ auth: state.auth })
export default connect(mapStateToProps)(Admin)
